import * as Acciones from './Acciones';
import { URLBase } from '../compartido/URLBase';
import { actions } from 'react-redux-form';
import { establecerGalleta, obtenerGalleta } from '../componentes/Utilidades/gestorCookies';

// Sesión usuario
export const iniciarSesion = (usuario, contrasena) => (dispatch) => {

    dispatch(iniciandoSesion());

    const datos = {
        datos: {
            login: usuario,
            contrasena: contrasena
        }
    }

    return fetch(URLBase + 'usuario/login/', {

        method: 'POST',
        body: JSON.stringify(datos),
        headers: {
            Accept: 'application/json',
            'Content-type': 'application/json'
        }
    })
        .then(response => {

            if (response.ok) {

                return response;

            }

            else {

                var error = new Error("Ha ocurrido un error con el siguiente mensaje:\n" + response.status + " : " + response.statusText);
                error.response = response;
                throw error;

            }


        }, error => {

            var mensErr = new Error(error.message);
            throw mensErr;

        })
        .then(response => {

            return response.json()
        })
        .then(usuario => {

            if (Object.keys(usuario).length === 0) {
                console.log("Sesión no iniciada : Datos incorrectos")
                dispatch(sesionNoIniciada("Datos incorrectos"))
            } else {
                establecerGalleta('usuario', usuario.galleta, 60);
                dispatch(sesionIniciada(usuario));
            }
            //


        })
        .catch(error => {
            console.log("Sesión no iniciada : " + error.message)
            dispatch(sesionNoIniciada(error.message));

        })
}

// Sesión
export const iniciandoSesion = () => ({

    type: Acciones.INICIANDO_SESION,

});

export const sesionIniciada = (usuario) => ({

    type: Acciones.SESION_INICIADA,
    payload: usuario
});

export const sesionNoIniciada = (mensErr) => ({

    type: Acciones.SESION_NO_INICIADA,
    payload: mensErr

});
